/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Редактирвоить ОПФ.
 */
export interface EditOPFType { 
    /**
     * Наименование ОПФ.
     */
    name?: string;
    /**
     * Описание ОПФ.
     */
    description?: string;
    /**
     * ID
     */
    id?: number;
}

